import { useRef, useState } from 'react'

interface Toast {
  id: number
  title?: string
  message: string
  severity: 'success' | 'error'
  ref: React.RefObject<HTMLFuelToastElement>
}

const useToastController = () => {
  const [toasts, setToasts] = useState<Toast[]>([])
  const ref = useRef<HTMLFuelToastElement>()

  const removeToast = (id: number) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id))
  }

  const addToast = ({
    title,
    message,
    severity,
  }: {
    title?: string
    message: string
    severity: 'success' | 'error'
  }) => {
    const newToast = {
      id: Date.now(),
      title,
      message,
      severity,
      ref,
    }

    setToasts((prevToasts) => [...prevToasts, newToast])

    setTimeout(() => newToast.ref.current?.open(), 100)

    setTimeout(() => removeToast(newToast.id), 6000)
  }

  return { toasts, addToast, removeToast }
}

export default useToastController
